module.exports = __webpack_public_path__ + "static/media/bg3.e26780a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/editor/layout/addons/props/components/bgTheme/bg/bg3.jpg
// module id = 3324
// module chunks = 0